<template>
  <div class="summary-info">
    <div class="ri-medium-display">
      <league
        :number-of-participants="numberOfParticipantsWhoSpentLessThanChallengeGoal"
        label-text="עומדים ביעד"
        :bold-label-text="successBoldText"
        :participants-circle-data="successParticipantsCircleData"
      />
    </div>
    <div class="margin-right-ml">
      <league
        :number-of-participants="numberOfParticipantsWhoExceededChallengeGoal"
        label-text="לא עומדים ביעד"
        :bold-label-text="failedBoldText"
        :participants-circle-data="failedParticipantsCircleData"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import * as _ from 'lodash';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useChallengeStore } from '../../stores/challenge';
import league from './League.vue';
import { Participant } from '../../types/participant';

const challengeStore = useChallengeStore();
const {
  hasExceededChallengeGoal,
  numberOfParticipantsWhoSpentLessThanChallengeGoal,
  numberOfParticipantsWhoExceededChallengeGoal,
  firstName,
  failedStackParticipants,
  successStackParticipants,
} = storeToRefs(challengeStore);

const successBoldText = computed(() => {
  if (!hasExceededChallengeGoal.value && firstName.value) {
    return (numberOfParticipantsWhoSpentLessThanChallengeGoal.value === 1) ? `${firstName.value}, ריספקט!` : `${firstName.value} `;
  }
  return undefined;
});

const failedBoldText = computed(() =>
  ((hasExceededChallengeGoal.value && firstName.value && numberOfParticipantsWhoExceededChallengeGoal.value > 1)
    ? `${firstName.value} ` : undefined));

const successParticipantsCircleData = computed(() =>
  _.map(successStackParticipants.value as Participant[], p => ({ emoji: p.challengeData.emoji, color: p.challengeData.color })));

const failedParticipantsCircleData = computed(() =>
  _.map(failedStackParticipants.value as Participant[], p => ({ emoji: p.challengeData.emoji, color: p.challengeData.color })));

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

.summary-info {
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: start;
  position: relative;
  margin-bottom: $ri-spacing-ml;

  > div:first-child {
    width: 38%;
    border-left: 1px solid $riseup_gray_0;
  }

  .info-text {
    align-self: center;
  }
}
</style>
